// 2026-05-08: переключён default V1→V2. V2 содержит все недавние улучшения
// (centroid scope labels, hybrid+places, progressive field labels, scope-clipped
// cloud-mask, no duplicate legend). V1 (`pages/map/legacy.tsx`) оставлен в
// codebase как fallback через cookie `mapV2=0` или URL `?_mapV2=0`. Founder
// UAT 2026-05-08-1 показал что legacy default = 2 дублирующиеся legend +
// неправильный scope filter behavior.
const ENV_FLAG = (import.meta.env.VITE_MAP_REWRITE ?? 'true').toString().toLowerCase() === 'true';

function readCookieOverride(): boolean | null {
  if (typeof document === 'undefined') return null;
  const url = new URLSearchParams(window.location.search);
  if (url.get('_mapV2') === '1') {
    document.cookie = 'mapV2=1; path=/; max-age=86400';
    return true;
  }
  if (url.get('_mapV2') === '0') {
    document.cookie = 'mapV2=0; path=/; max-age=86400';
    return false;
  }
  const m = /(?:^|;\s*)mapV2=(\d)/.exec(document.cookie);
  if (!m) return null;
  return m[1] === '1';
}

export function isMapV2Enabled(): boolean {
  const override = readCookieOverride();
  if (override !== null) return override;
  return ENV_FLAG;
}

// ── AK-193: raster tile size (256 ↔ 512) ──────────────────────────────────
//
// A raster source `tileSize:512` requests tiles ONE zoom level coarser than
// `tileSize:256`, so MapLibre fetches ¼ as many tiles — the single largest
// request-count lever in ADR-037. BUT the backend renderer currently emits
// fixed 256×256 PNGs (`backend/.../rasters/renderer.py:TILE_SIZE = 256`); the
// 512-render is a SEPARATE backend lot (#11, domain-satellite). Flipping the
// frontend to 512 before the backend serves 512 would upscale 256px imagery
// to 512 logical px → blurry NDVI (a UX regression).
//
// So 512 is gated behind a flag and stays 256 by default. Flip via env
// (`VITE_RASTER_TILE_SIZE=512`) once the backend lot ships, or per-session for
// A/B cold-storm measurement via URL `?_tile512=1` / `?_tile512=0`
// (cookie-persisted, 1 day) — mirrors the `_mapV2` override mechanism.
const ENV_TILE_512 =
  (import.meta.env.VITE_RASTER_TILE_SIZE ?? '256').toString() === '512';

function readTile512Override(): boolean | null {
  if (typeof document === 'undefined') return null;
  const url = new URLSearchParams(window.location.search);
  if (url.get('_tile512') === '1') {
    document.cookie = 'tile512=1; path=/; max-age=86400';
    return true;
  }
  if (url.get('_tile512') === '0') {
    document.cookie = 'tile512=0; path=/; max-age=86400';
    return false;
  }
  const m = /(?:^|;\s*)tile512=(\d)/.exec(document.cookie);
  if (!m) return null;
  return m[1] === '1';
}

/**
 * Pixel size MapLibre requests for NDVI/RGB/cloud raster tile sources.
 * Returns 512 only when explicitly enabled (env or A/B override); 256 default.
 * Used at source registration (`v2.tsx`) and on every raster source recreate
 * (`recreateRasterSource`) so the two stay in lock-step.
 */
export function rasterTileSize(): 256 | 512 {
  const override = readTile512Override();
  const enabled = override !== null ? override : ENV_TILE_512;
  return enabled ? 512 : 256;
}
